import React, { useState } from "react";
import {
  isPlatform,
  IonModal,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonIcon,
} from "@ionic/react";
import "./LoadMap.scss";
import { PCMilerSatelliteMap } from "../../../components/shared/PCMilerMap";

export interface ILoadPCmilerMapsSatelliteProps {
  locationName: string;
  shipmentId: string;
  position?: any;
  showSatelliteMap: boolean;
  onDismissSatelliteMap: () => void;
}

export const LoadPCmilerMapsSatellite = (
  props: ILoadPCmilerMapsSatelliteProps
) => {
  const isDesktop = isPlatform("desktop");
  const {
    shipmentId,
    showSatelliteMap,
    onDismissSatelliteMap,
    locationName,
    position,
  } = props;
  const [showMap, setShowMap] = useState<boolean>(false);

  return (
    <>
      <IonModal
        isOpen={showSatelliteMap}
        onDidDismiss={() => {
          onDismissSatelliteMap();
        }}
        animated={false}
        cssClass={`${
          isDesktop ? "satellite-view-desktop" : "satellite-view-mobile"
        }`}
        onDidPresent={() => {
          setShowMap(true);
        }}
        onWillDismiss={() => {
          setShowMap(false);
        }}
      >
        <IonToolbar className="satellite-toolbar">
          <IonButtons
            slot="end"
            onClick={() => {
              onDismissSatelliteMap();
            }}
          >
            <IonIcon className="satellite-close" icon="close" />
          </IonButtons>
          <IonTitle className="satellite-title">{`${
            isDesktop ? "Satellite view" : shipmentId
          }`}</IonTitle>
        </IonToolbar>
        {showMap && (
          <PCMilerSatelliteMap
            locationName={locationName}
            position={position}
          />
        )}
      </IonModal>
    </>
  );
};
